import React from "react";
import { useLocation } from "react-router";
import { Button } from "@sscs/ui";
import { LoginContentWrapper } from "Components";
import { LOGIN_ROUTE, VERIFY_SSO_LOGIN_ROUTE } from "Constants";
import { OidcSsoLoginInfo } from "Types";
import {
  buildOidcAuthorizationUrl,
  buildOidcStateParam,
  getBaseRoute,
  maybeNavigateLocation,
} from "Utils";
import EulaLink from "../EulaLink/EulaLink";
import SupportLoginLink from "../SupportLoginLink/SupportLoginLink";

type OIDCLoginProps = {
  ssoInfo: OidcSsoLoginInfo;
};

const OIDCLogin = ({ ssoInfo }: OIDCLoginProps): React.JSX.Element => {
  const location = useLocation();
  const navigateToAfterLogin = maybeNavigateLocation(location.state);

  const handleOIDCLogin = (): void => {
    window.location.href = buildOidcAuthorizationUrl({
      authorizationUrl: ssoInfo.oidc_authorization_url,
      clientId: ssoInfo.oidc_client_id,
      responseType: ssoInfo.oidc_response_type,
      scopes: ssoInfo.oidc_scopes,
      redirectUri: `${getBaseRoute()}/${LOGIN_ROUTE}/${VERIFY_SSO_LOGIN_ROUTE}`,
      state: buildOidcStateParam({
        state: ssoInfo.oidc_state,
        payload: navigateToAfterLogin,
      }),
      nonce: ssoInfo.oidc_nonce,
    });
  };

  return (
    <LoginContentWrapper
      title="SSO login"
      byline="Your organization has enabled SSO so you can log in quickly and easily with your corporate account"
    >
      <Button
        isFullWidth
        onClick={handleOIDCLogin}
        color="primary"
        size="large"
      >
        Log in with SSO
      </Button>
      <EulaLink />
      <SupportLoginLink />
    </LoginContentWrapper>
  );
};

export default OIDCLogin;
